import React from 'react';

import { DownCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import Popover from 'components/lib/Popover';
import { CommunityType } from 'types/communities';

import { SHOP_REQUEST_STATUS_LABELS, SHOP_REQUEST_TYPE } from '../constants';
import { MysteryShopRequestInbound } from '../types';
import { getShopRequestPropagationCommunities } from '../utils';

const Container = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
`;

const CommunityList = styled.div`
  display: flex;
  padding: 0px 5px;
  flex-direction: column;
  gap: 5px;
`;

const CommunityListItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 30px;
  font-size: 12px;
`;

const CommunityName = styled.span`
  color: var(--text-primary);
`;

const CompanyName = styled.span`
  color: var(--text-secondary);
`;

const StyledDownCircleOutlined = styled(DownCircleOutlined)`
  font-size: 16px;
`;

type Props = {
  shopRequest: MysteryShopRequestInbound;
};

const ShopRequestsPropagation = ({ shopRequest }: Props) => {
  if (shopRequest.request_type !== SHOP_REQUEST_TYPE.MYSTERY_SHOP) {
    return null;
  }

  const shopRequestApproved = shopRequest.status === SHOP_REQUEST_STATUS_LABELS.APPROVED;
  const communities = (
    shopRequestApproved
      ? (shopRequest.propagation?.communities ?? [])
      : getShopRequestPropagationCommunities(shopRequest)
  ).filter(Boolean);

  return (
    <Container data-test-id="propagate-to-comm">
      {(communities ?? []).length > 0 && (
        <>
          <span data-test-id="propagate-to-comm-nr">
            {communities.length} {communities.length > 1 ? 'Communities' : 'Community'}
          </span>
          <Popover
            content={
              <CommunityList>
                {communities.map((community: CommunityType) => (
                  <CommunityListItem key={community.id}>
                    <CommunityName>{community.name}</CommunityName>
                    <CompanyName>{community.company.name}</CompanyName>
                  </CommunityListItem>
                ))}
              </CommunityList>
            }
            placement={'bottom'}
          >
            <StyledDownCircleOutlined />
          </Popover>
        </>
      )}
    </Container>
  );
};

export default ShopRequestsPropagation;
